<template>
  <el-container class="contain">
    <el-aside class="sidebar"
              width="260px">

      <el-menu :default-active="selectedNav"
               class="nav-menu"
               @select="selectNav"
               active-text-color="#ffd04b"
               active-background-color="#409eff">
        <div class="logo">
          <img src="@/assets/logo.png"
               alt="Logo"
               style=" margin-bottom: -20px;" />
        </div>
        <template v-for="item in navItems">
          <el-menu-item v-if="item !== '创建制图'"
                        :key="item"
                        :index="item"
                        class="navmenu"
                        :class="{ 'navmenu-active': item === selectedNav, 'warning-active': item === '设备预警' && hasEquipmentWarning }">
            <div class="navmenu-inner">
              <img :src="navIcons[item]"
                   class="navmenu-icon" />
              <span class="navmenu-title">{{ item }}</span>
              <img :src="item === selectedNav ? '/img/star-active.png' : '/img/star.png'"
                   class="navmenu-star"
                   alt="star" />
            </div>
          </el-menu-item>
          <template v-else>
            <el-menu-item class="navmenu create-cartography-menu"
                          :class="{ 'navmenu-active': selectedNav === '创建制图' }"
                          @click="handleCreateCartographyClick"
                          :key="item"
                          :index="item">
              <div class="navmenu-inner">
                <img :src="navIcons['创建制图']"
                     class="navmenu-icon" />
                <span class="navmenu-title">创建制图</span>
                <i :class="isCreateCartographyOpen ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                   style="margin-left:auto; color: #fff;"></i>
              </div>
            </el-menu-item>
            <transition name="submenu-fade">
              <div v-if="isCreateCartographyOpen"
                   class="submenu-list-ui">
                <div v-for="sub in createCartographySubMenus"
                     :key="sub.key"
                     class="submenu-item-ui"
                     :class="{ 'submenu-active-ui': currentSubMenu === sub.key, 'submenu-disabled-ui': !sub.enabled }"
                     @click.stop="sub.enabled && selectCreateCartographySub(sub.key)">
                  <img :src="currentSubMenu === sub.key ? '/img/star-active.png' : '/img/star.png'"
                       class="navmenu-star-ui"
                       alt="star" />
                  <span class="submenu-title-ui">{{ sub.name }}</span>
                </div>
              </div>
            </transition>
          </template>
        </template>
      </el-menu>
    </el-aside>

    <el-container class="main-content">
      <el-header class="header">
        <div class="header-left">
          <img :src="navIcons[selectedNav]"
               class="nav-header-img"
               alt="icon" />
          <span class="nav-header-title">{{ selectedNav }}</span>
        </div>
        <div class="user-info">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <img src="/img/default-avatar.png"
                   class="user-avatar"
                   alt="avatar" /> {{ username }}
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">我的资料</el-dropdown-item>
              <el-dropdown-item command="change-password">修改密码</el-dropdown-item>
              <el-dropdown-item command="email-transfer">邮箱转让</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <el-main class="content">
        <component :is="currentView"
                   @switch-view="switchView" />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import StudentManagemengt from '../views/StudentManagemengt.new.vue';
import Profile from '../views/Profile.vue';
import TaskManagement from '../views/TaskManagement.vue';
import deviceManagement from '../views/deviceManagement.vue';
import repair from '../views/repair.vue';
import Rta from '../views/Rta.vue';
import MaterialParameters from '../views/MaterialParameters.vue';
import FeedBack from '../views/FeedBack.vue';
import CreateCartography from '../views/CreateCartography.vue';
import MemberCenter from '../views/MemberCenter.vue';
import EquipmentWarning from '../views/EquipmentWarning.vue';
import ResourceDownload from '../views/ResourceDownload.vue';
import TeachingTemplate from '../views/TeachingTemplate.vue';
import VideoCourses from '../views/VideoCourses.vue';
import axios from 'axios';
import { EventBus } from '@/utils/eventBus'
import { validateToken } from '@/utils/request';

export default {
  data() {
    return {
      username: '',
      institution: '',
      accountNumber: '',
      selectedNav: '', // 默认值，将在 created 钩子中更新
      navItems: [
        '学生管理',
        '作品审核',
        '创建制图',
        '设备预警',
        '材料参数库',
        '实时监控',
        '设备管理',
        '维修报修',
        '反馈中心',
        '会员中心',
        '个人信息',
      ],
      hasEquipmentWarning: false,
      institutionName: '',
      warningCheckTimer: null,
      currentView: '',
      navToComponent: {
        '学生管理': 'StudentManagemengt',
        '作品审核': 'TaskManagement',
        '设备预警': 'EquipmentWarning',
        '材料参数库': 'MaterialParameters',
        '实时监控': 'Rta',
        '设备管理': 'deviceManagement',
        '维修报修': 'repair',
        '反馈中心': 'FeedBack',
        '会员中心': 'MemberCenter',
        '个人信息': 'Profile'
      },
      navIcons: {
        '学生管理': '/img/学生管理.png',
        '作品审核': '/img/作品审核.png',
        '创建制图': '/img/创建制图.png',
        '设备预警': '/img/设备预警.png',
        '材料参数库': '/img/材料参数库.png',
        '实时监控': '/img/实时监控.png',
        '设备管理': '/img/设备管理.png',
        '维修报修': '/img/维修报修.png',
        '反馈中心': '/img//反馈中心.png',
        '会员中心': '/img/会员中心.png',
        '个人信息': '/img/个人信息.png',
      },
      createCartographySubMenus: [
        { name: '制作', key: 'make', enabled: true },
        { name: '图库', key: 'gallery', enabled: true },
        { name: '课程中心', key: 'course', enabled: true },
      ],
      isCreateCartographyOpen: false,
      currentSubMenu: '',
      // 获取存储的用户信息
      userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
    };
  },
  components: {
    StudentManagemengt,
    Profile,
    TaskManagement,
    deviceManagement,
    repair,
    Rta,
    MaterialParameters,
    FeedBack,
    CreateCartography,
    MemberCenter,
    EquipmentWarning,
    ResourceDownload,
    TeachingTemplate,
    VideoCourses,
    CreateCartographyMake: () => import('../views/CreateCartographyMake.vue'),
    CreateCartographyGallery: () => import('../views/CreateCartographyGallery.vue'),
    CreateCartographyCourse: () => import('../views/CreateCartographyCourse.vue'),
  },
  created() {
    // 获取存储的用户信息
    this.userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    // 优先读取 localStorage 的 selectedNav
    const savedNav = localStorage.getItem('selectedNav');
    this.selectedNav = savedNav ? savedNav : '学生管理';
    // 同步 currentView
    const comp = this.navToComponent[this.selectedNav];
    if (comp) {
      this.currentView = comp;
    }
    // 从userInfo中获取数据
    if (this.userInfo) {
      this.username = this.userInfo.userName || '';
      this.institution = this.userInfo.institutionName || '';
      this.institutionName = this.userInfo.institutionName.replace(/^"|"$/g, '') || ''; // 设置institutionName
      this.accountNumber = this.userInfo.accountNumber || '';
    }

    // 如果userInfo中没有数据，则尝试从服务器获取
    if (!this.userInfo.userName) {
      // this.fetchData();
    }

    // 启动设备预警检查
    this.startWarningCheck();
  },
  async mounted() {
    try {
      // 验证token
      await validateToken();
      // 立即检查设备预警
      console.log('mounted - 立即检查设备预警');
      this.checkDeviceWarnings();
    } catch (error) {
      console.error('Token验证失败:', error);
      this.$message.error('登录已过期，请重新登录');
      this.$router.push('/login');
    }
  },
  beforeDestroy() {
    EventBus.$off('userNameUpdated');
    EventBus.$off('warningAcknowledged');
    if (this.warningCheckTimer) {
      clearInterval(this.warningCheckTimer);
    }
  },
  methods: {
    async selectNav(item) {
      try {
        // 验证token
        await validateToken();
        this.selectedNav = item;
        localStorage.setItem('selectedNav', item);

        const comp = this.navToComponent[item];
        if (comp) {
          this.currentView = comp;
        }

        // 自动收起创建制图下拉框
        if (item !== '创建制图' && this.isCreateCartographyOpen) {
          this.isCreateCartographyOpen = false;
        }

        // 当选择设备预警时，发送重置确认状态的事件
        if (item === '设备预警') {
          console.log('点击设备预警，发送重置事件');
          // 确保先发送数据，再重置确认状态
          this.checkDeviceWarnings().then(() => {
            EventBus.$emit('resetWarningAcknowledge');
          });
        }
      } catch (error) {
        console.error('Token验证失败:', error);
        this.$message.error('登录已过期，请重新登录');
        this.$router.push('/login');
      }
    },
    handleCommand(command) {
      switch (command) {
        case 'profile':
          this.selectedNav = '个人信息';
          break;
        case 'change-password':
          this.selectedNav = '个人信息';
          break;
        case 'email-transfer':
          this.selectedNav = '个人信息';
          break;
        case 'logout':
          this.logout();
          break;
        default:
          break;
      }
    },
    logout() {
      this.$confirm('确认退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 清除所有本地存储的数据
        localStorage.clear();
        // 显示退出成功消息
        this.$message.success('退出成功');
        // 跳转到登录页
        this.$router.push('/login');
      }).catch(() => {
        this.$message.info('已取消退出');
      });
    },
    fetchData() {
      const accountNumber = localStorage.getItem('userAccountNumber');
      axios.get(`api/auth/selectTeachUsersByaccountNumber?accountNumber=${accountNumber}`)
        .then(response => {
          console.log('用户信息:', response);
          if (response.data.code === 0 && response.data) {
            this.username = response.data.userName;
            this.institutionName = response.data.institutionName;
            localStorage.setItem('userInstitutionName', JSON.stringify(this.institutionName));
          } else {
            this.$message.error(response.msg || '获取用户信息失败');
          }
        })
        .catch(error => {
          console.error('获取用户信息失败:', error);
          this.$message.error(error.message || '获取用户信息失败');
        });
    },
    startWarningCheck() {
      // 立即检查一次
      this.checkDeviceWarnings();
      // 设置定时器，每秒检查一次
      this.warningCheckTimer = setInterval(this.checkDeviceWarnings, 1000);
    },
    async checkDeviceWarnings() {
      try {
        // 如果institutionName为空，尝试从localStorage获取
        if (!this.institutionName) {
          const storedInstitutionName = localStorage.getItem('userInstitutionName');
          if (storedInstitutionName) {
            try {
              // 尝试解析JSON
              this.institutionName = JSON.parse(storedInstitutionName);
            } catch (e) {
              // 如果不是JSON格式，直接使用
              this.institutionName = storedInstitutionName;
            }
          }

          // 如果仍然为空，尝试从userInfo获取
          if (!this.institutionName && this.userInfo && this.userInfo.institutionName) {
            this.institutionName = this.userInfo.institutionName;
          }

          // 记录获取到的机构名称
          console.log('从备选来源获取的机构名称:', this.institutionName);
        }

        // 如果institutionName仍然为空，无法进行请求
        if (!this.institutionName) {
          console.error('无法获取机构名称，设备预警检查失败');
          return;
        }

        // 确保institutionName是字符串
        let institutionNameStr = this.institutionName;
        if (typeof institutionNameStr !== 'string') {
          institutionNameStr = String(institutionNameStr);
        }

        // 移除可能的引号
        institutionNameStr = institutionNameStr.replace(/^"|"$/g, '');

        const encodedInstitutionName = encodeURIComponent(institutionNameStr);
        console.log('请求设备数据的机构名称:', institutionNameStr);

        const response = await axios.get(`/api/mqtt/selectAllByDevid?institutionName=${encodedInstitutionName}`);

        if (response.data.code === 200) {
          const devices = response.data.data
            .filter(item => item.data && item.data.length > 0)
            .map(item => item.data[0]);

          // 检查是否有任何设备异常
          const hasAnyWarning = devices.some(device =>
            device.fire === 0 ||
            device.waterLevel === 0 ||
            device.waterTemperatureAlarm === 0 ||
            device.cap === 0
          );

          // 更新警告状态
          this.hasEquipmentWarning = hasAnyWarning;

          console.log('设备检查：', {
            hasWarning: hasAnyWarning,
            deviceCount: devices.length
          });

          // 通过 EventBus 发送设备数据给设备预警页面
          EventBus.$emit('deviceDataUpdated', devices);
        } else {
          console.error('获取设备数据失败:', response.data);
        }
      } catch (error) {
        console.error('获取设备状态失败:', error);
      }
    },
    switchView(viewName) {
      this.currentView = viewName;
    },
    toggleCreateCartography() {
      this.isCreateCartographyOpen = !this.isCreateCartographyOpen;
    },
    selectCreateCartographySub(key) {
      this.currentSubMenu = key;
      this.selectedNav = '创建制图';
      // 选择二级菜单时切换主内容区
      if (key === 'make') {
        this.currentView = 'CreateCartographyMake';
      } else if (key === 'gallery') {
        this.currentView = 'CreateCartographyGallery';
      } else if (key === 'course') {
        this.currentView = 'CreateCartographyCourse';
      }
    },
    handleCreateCartographyClick() {
      this.toggleCreateCartography();
      // 如果展开，则默认选中第一个子菜单，并切换主内容区
      if (!this.isCreateCartographyOpen && this.createCartographySubMenus.length > 0) {
        const firstKey = this.createCartographySubMenus[0].key;
        this.selectCreateCartographySub(firstKey);
        this.switchView(firstKey); // 保证内容区同步切换
      }
    },
  }
};
</script>

<style scoped>
.contain {
  height: 100vh;
  width: 100%;
}

.sidebar {
  width: 260px !important;
  min-width: 200px;
  max-width: 100vw;
  background-color: #fff;
  overflow: hidden;
  height: 100vh;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.1);
}

.logo {
  padding: 20px;
  text-align: left;
  /* background-color: #fff; */
}

.logo img {
  height: 50px;
}

.nav-menu {
  width: 100%;
  height: 100%;
  border-right: none;
  display: flex;
  flex-direction: column;
  background-image: url("/img/ceib.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-color: rgba(64, 158, 255, 0.9);
  align-items: center;
  box-shadow: 5px 0 5px rgba(0, 0, 0, 0.1) !important;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.header {
  height: 60px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-left {
  display: flex;
  align-items: center;
}

.nav-header-img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
  vertical-align: middle;
}

.nav-header-title {
  font-size: 24px;
  font-weight: 500;
  color: #2ea2fa;
}

.user-info {
  display: flex;
  align-items: center;
  margin-right: 50px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #333;
  display: flex;
  align-items: center;
}

.user-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 7px;
  vertical-align: middle;
}

.content {
  flex: 1;
  padding: 20px;
  background: #ebf6fe;
}

.navmenu {
  width: 90%;
  text-align: center;
  color: #fff;
  margin-bottom: 12px;
  border-radius: 10px !important;
}
.navmenu:first-child {
  margin-top: -20px !important;
}

.navmenu-inner {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 10px;
  transition: background 0.2s;
  background: transparent;
}

.navmenu-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
  transition: filter 0.2s;
}

.navmenu-title {
  font-size: 18px;
  font-weight: 500;
  transition: color 0.2s;
}

.navmenu-star {
  margin-left: auto;
  width: 18px;
  height: 18px;
  display: inline-block;
  transition: filter 0.2s;
}

.el-menu-item.navmenu {
  background: transparent !important;
  height: 56px;
  line-height: 56px;
  padding: 0 !important;
  border: none !important;
}

.el-menu-item.navmenu-active .navmenu-inner {
  background: #fff;
  color: #409eff;
  border-radius: 16px;
}

.el-menu-item.navmenu-active .navmenu-title {
  color: #409eff;
}

.el-menu-item.navmenu-active .navmenu-icon {
  filter: brightness(0) saturate(100%) invert(47%) sepia(85%) saturate(746%)
    hue-rotate(176deg) brightness(99%) contrast(101%);
}

.el-menu-item.navmenu-active .navmenu-star {
  filter: brightness(1) saturate(2) drop-shadow(0 0 2px #409eff);
}

.el-menu-item.navmenu:not(.navmenu-active) .navmenu-title {
  color: #fff;
}

.el-menu-item.navmenu:not(.navmenu-active) .navmenu-star {
  filter: grayscale(1) brightness(2) opacity(0.8);
}

.el-menu-item.navmenu:not(.navmenu-active) .navmenu-icon {
  filter: brightness(100) grayscale(1) opacity(0.8);
}

.warning-active {
  color: #e6a23c !important;
}

.submenu-list-ui {
  background: transparent;
  border-radius: 16px;
  margin: 8px 0 0 0;
  padding: 24px 0 20px 0;
  box-shadow: none;
  width: 90%;
  margin-left: 5%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.submenu-item-ui {
  display: flex;
  align-items: center;
  padding: 0 0 0 32px;
  height: 40px;
  width: 100%;
  cursor: pointer;
  border-radius: 8px;
  margin-bottom: 6px;
  transition: background 0.2s;
}

.submenu-title-ui {
  font-size: 18px;
  font-weight: 500;
  margin-left: 10px;
  color: #a2d8ff;
}

.navmenu-star-ui {
  width: 20px;
  height: 20px;
}

.submenu-active-ui .submenu-title-ui {
  color: #ffffff;
}

.submenu-active-ui .navmenu-star-ui {
  filter: none;
}

.submenu-disabled-ui {
  cursor: not-allowed;
  opacity: 0.5;
}

.submenu-disabled-ui .submenu-title-ui {
  color: #bfcbd9;
}

.submenu-fade-enter-active,
.submenu-fade-leave-active {
  transition: all 0.2s;
}
.submenu-fade-enter,
.submenu-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@media (max-height: 800px) {
  .sidebar {
    height: 100vh;
    min-height: 400px;
    overflow: hidden;
  }
  .navmenu {
    margin-bottom: 8px;
    /* overflow: hidden; */
  }
  .navmenu-inner {
    padding: 4px 8px;
  }
  .submenu-list-ui {
    padding: 12px 0 10px 0;
  }
}
</style>

<!-- 设备预警红色闪烁动画样式，务必全局生效 -->
<style>
.el-menu-item.navmenu.warning-active .navmenu-title {
  color: #ff3b30 !important;
  animation: warning-blink 1s steps(2, jump-none) infinite;
}
.el-menu-item.navmenu.warning-active {
  background: rgba(255,59,48,0.15) !important;
  box-shadow: 0 0 8px 2px #ff3b30;
  animation: warning-blink-bg 1s steps(2, jump-none) infinite;
}
@keyframes warning-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.2; }
}
@keyframes warning-blink-bg {
  0%, 100% { box-shadow: 0 0 8px 2px #ff3b30; }
  50% { box-shadow: 0 0 0 0 transparent; }
}
</style>
